<template>
  <div>
    <ed-exame :intExameId="0" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdExame from "@/components/cadastro/exame/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdExame },
  mounted() {},
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>